import InboxContainer from './InboxContainer'

export default options => {
  const {
    config,
    layout
  } = options

  return {
    inbox: new InboxContainer({config, layout})
  }
}
